import { FormEvent, ReactNode, useState } from "react";
import styled from "styled-components";
import {
  JazzLogoImg,
  LobbyBackground,
  LobbyContent,
  LobbyFooterBar,
  LogoImg,
  LogoRow,
  RegulatoryCode,
} from "./blueShell";
import { PrimaryPillButton } from "./quizChrome";
import { getStoredPassword, setStoredPassword } from "../game/auth";
import { colors } from "../theme/colors";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL ?? "http://localhost:3000";

const AuthCard = styled.div`
  background: #fff;
  border-radius: 1rem;
  padding: 2.5rem;
  max-width: 25rem;
  margin: 2.5rem auto 0;
  color: ${colors.black};

  h2 {
    margin: 0 0 1.25rem;
  }
`;

const PasswordInput = styled.input`
  width: 100%;
  box-sizing: border-box;
  padding: 0.75rem 1rem;
  border-radius: 0.5rem;
  border: 1px solid #ccc;
  font-family: 'Jost', sans-serif;
  font-size: 1rem;
`;

const ErrorText = styled.p`
  color: ${colors.red};
  font-weight: bold;
`;

const SubmitButton = styled(PrimaryPillButton)`
  width: 100%;
  margin-top: 1.25rem;
`;

export default function AuthGate({ children }: { children: ReactNode }) {
  const [password, setPassword] = useState<string | null>(getStoredPassword());
  const [input, setInput] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  if (password) {
    return <>{children}</>;
  }

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(`${BACKEND_URL}/auth/verify`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ password: input }),
      });
      if (!response.ok) {
        setError("Mot de passe incorrect.");
        return;
      }
      setStoredPassword(input);
      setPassword(input);
    } catch {
      setError("Impossible de contacter le serveur.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <LobbyBackground>
      <LobbyContent>
        <LogoRow>
          <LogoImg src="/images/LOGO_EPI.png" alt="EPI & CO" />
        </LogoRow>
        <AuthCard>
          <h2>Accès protégé</h2>
          <form onSubmit={handleSubmit}>
            <PasswordInput
              type="password"
              value={input}
              onChange={(event) => setInput(event.target.value)}
              placeholder="Mot de passe"
              autoFocus
            />
            {error && <ErrorText>{error}</ErrorText>}
            <SubmitButton type="submit" disabled={loading || input.length === 0}>
              {loading ? "Vérification..." : "Valider"}
            </SubmitButton>
          </form>
        </AuthCard>
      </LobbyContent>
      <LobbyFooterBar>
        <JazzLogoImg src="/images/logo_jazz_pharma_color.png" alt="Jazz Pharmaceuticals" />
        <RegulatoryCode>FR-EPX-2600006 - 26/04/61680130/PM/003</RegulatoryCode>
      </LobbyFooterBar>
    </LobbyBackground>
  );
}
